import { useContext, useEffect, useRef, useState } from 'react';
import { retry, Subscription } from 'rxjs';

import { SocketContext } from '../providers/SocketProvider/SocketProvider';
import { telemetryNoticeError } from './useTelemetry';

export const useRoundCompletedListener = (
  callback: () => void,
  gameId: string,
  tenantId: string,
  slideId: string | null,
  count: number,
) => {
  const { gameAPI } = useContext(SocketContext);
  const savedCallback = useRef<() => void | null>();
  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  const [completedParticipants, setCompletedParticipants] = useState<
    { uid: string; timestamp: number }[]
  >([]);

  useEffect(() => {
    let sub: Subscription | undefined;

    if (gameId && slideId && gameAPI) {
      sub = gameAPI.game
        .onRoundCompletedByParticipants({ gameId, slideId, tenantId })
        .pipe(retry(5))
        .subscribe({
          next: participants => setCompletedParticipants(participants),
          error: error => {
            telemetryNoticeError(error, 'Error while listening to round completed');
          },
        });
    }

    return () => {
      if (sub) {
        sub.unsubscribe();
      }
    };
  }, [gameId, slideId, gameAPI]);

  const isComplete =
    count > 0 &&
    completedParticipants.length > 0 &&
    count === completedParticipants.length;

  useEffect(() => {
    if (isComplete && savedCallback.current) {
      savedCallback.current();
    }
  }, [isComplete]);

  return null;
};
